import {useState, React} from 'react'
import { Link } from "react-router-dom";
import {AiOutlineClose, AiOutlineMenu} from 'react-icons/ai'
import { useNavigate } from 'react-router-dom';

const NavBar =  () =>
{
    const navigate = useNavigate();
    const [nav, setNav] = useState(false);

    const closeNav = () => {
        setNav(false)
    }

    const handleNav = () => {
        setNav(!nav)
    }

    return (
        <div className ='flex text-center sm:text-left justify-between items-center h-24 max-w-[1240px] mx-auto text-white'>
            <h1 className='w-full text-3xl font-bold text-[#00fd9a]'>AHMAD'S DEV GALLERY.</h1>

            <ul className='hidden sm:flex'>
                <li className='transition hover:text-[#00fd9a] p-4'><Link to={`/`}>Home</Link></li>
                <li className='transition hover:text-[#00fd9a] p-4'><Link to={`/projects/`}>Projects</Link></li>
                <li className='transition hover:text-[#00fd9a] p-4'><Link to={`/tech/`}>Tech</Link></li>   
                <li className='transition hover:text-[#00fd9a] p-4'><Link to={`/contact/`}>Contact</Link></li>
            </ul>
            
            <div onClick={handleNav} className='block sm:hidden mr-5'>
                {nav?<AiOutlineClose size = {20}/>:<AiOutlineMenu size={20}/>}
            </div>

            <div className={nav?'fixed left-0 top-0 w-[60%] h-full border-r border-r-gray-900 bg-[#000300] ease-in-out duration-500':'hidden fixed left-[-100%]'}>
            <h1 className='w-full text-3xl mt-3 font-bold text-[#00fd9a]'>AHMAD'S DEV GALLERY.</h1>

                <ul className='p-4    '>
                <li onClick={()=>{closeNav();navigate('/')}} className='transition hover:text-[#00fd9a] p-4 border-b border-gray-600'>Home</li>
                <li onClick={()=>{closeNav();navigate('/projects')}} className='transition hover:text-[#00fd9a] p-4 border-b border-gray-600'>Projects</li>
                <li onClick={()=>{closeNav();navigate('/tech')}} className='transition hover:text-[#00fd9a] p-4 border-b border-gray-600'>Tech</li>   
                <li onClick={()=>{closeNav();navigate('/contact')}} className='transition hover:text-[#00fd9a] p-4'>Contact</li>
                </ul>
            </div>
        </div>
    )
}

export default NavBar;